// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
/** Returns each filter's value by its name, leaving out filters with no value. */
export function filterValues(filters) {
  const values = {};

  for (const filter of filters) {
    const value = filter.value;

    // An sp-select keeps its item's value type, so a numeric id has no length.
    if (value != null && String(value).length) {
      values[filter.getAttribute("name")] = value;
    }
  }

  return values;
}

/** Clears every filter and announces each through a bubbling `change`. */
export function clearFilters(filters) {
  for (const filter of filters) {
    filter.value = "";
    filter.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
